import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Typography,
  Grid,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import CustomDialog from 'widgets/component/CustomDialog';
import axiosTokenInstance from 'services/api/backoffice';

const PreRegisterGiftSimsForm = ({ onSubmit, loading, processCompleted, setProcessCompleted }) => {
  const [csvFile, setCsvFile] = useState(null);
  const [productId, setProductId] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [products, setProducts] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axiosTokenInstance.get(`/api/orders/product-list`);
        console.log('Response de productos', response.data);
        setProducts(response?.data?.products || []);
      } catch (err) {
        console.error('Error al obtener los productos', err);
        setDialogMessage('Error al cargar productos disponibles.');
        setIsDialogOpen(true);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (processCompleted) {
      setCsvFile(null);
      setProductId('');
      setProcessCompleted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processCompleted]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith('.csv')) {
      setCsvFile(file);
    } else {
      setDialogMessage('Solo se aceptan archivos .csv');
      setIsDialogOpen(true);
    }
  };

  const handleFileRemove = () => {
    setCsvFile(null);
  };

  const handleProcessClick = () => {
    if (csvFile) {
      if (!productId || productId === '') {
        setErrorMessage('El producto es requerido');
        return;
      }
      setErrorMessage('');
      onSubmit(csvFile, productId);
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <Box sx={{ width: { xs: '100%', md: '40%' } }} paddingLeft={5}>
      <Grid size={5} paddingTop={3}>
        <FormControl fullWidth error={errorMessage !== ''}>
          <InputLabel>Selecciona un producto</InputLabel>
          <Select
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            label='Selecciona un producto'
          >
            {products.map((product) => (
              <MenuItem
                key={product.carrier_product_id}
                value={product.carrier_product_id}
                disabled={product.carrier_product_name.includes('[No Disponible]')}
              >
                {product.carrier_product_name}
              </MenuItem>
            ))}
          </Select>
          {errorMessage && (
            <Typography variant='caption' color='error'>
              {errorMessage}
            </Typography>
          )}
        </FormControl>
      </Grid>

      <Box mt={3} display='flex' alignItems='center' gap={2}>
        <Typography variant='body1' width={300}>
          {csvFile ? csvFile.name : 'Carga un archivo .csv para continuar con el pre-registro'}
        </Typography>

        {!csvFile && (
          <Button variant='contained' component='label' color='primary'>
            Cargar archivo
            <input type='file' accept='.csv' hidden onChange={handleFileChange} />
          </Button>
        )}

        {csvFile && (
          <Button variant='contained' color='error' onClick={handleFileRemove}>
            Eliminar archivo
          </Button>
        )}
      </Box>

      <Box mt={2}>
        <Button
          variant='contained'
          disabled={!csvFile || loading}
          sx={{
            backgroundColor: csvFile ? 'primary.main' : 'grey.400',
          }}
          onClick={handleProcessClick}
        >
          {loading ? <CircularProgress size={20} /> : 'Procesar Pre registro'}
        </Button>
      </Box>

      <CustomDialog
        title='Mensaje'
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleCloseDialog,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
    </Box>
  );
};

export default PreRegisterGiftSimsForm;
